<template>
  <i
    v-if="sortBy === column"
    :class="`fa fa-sort-${iconType}-${sortByDirTxt}`"
  ></i>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    column: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconType() {
      return this.sortByObj.iconType;
    },
    ...mapGetters({
      sortBy: "settings/sortBy",
      sortByObj: "settings/sortByObj",
      sortByDirTxt: "settings/sortByDirTxt",
    }),
  },
};
</script>
